// 获取token
const tokenKey = "token";
const userInfo = localStorage.getItem("vuex")
    ? JSON.parse(localStorage.getItem("vuex")).user
    : {};
export function getToken() {
    return localStorage.getItem(tokenKey);
}

export function saveToken(tokenValue) {
    return localStorage.setItem(tokenKey, tokenValue);
}

export function removeToken() {
    return localStorage.removeItem(tokenKey);
}

// 获取用户companyId
export function getCompanyId() {
    return userInfo.cid || null;
}

// 获取用户role
export function getRole() {
    return userInfo.loginId && userInfo.loginId !== "personal" && userInfo.cid
        ? "ENTERPISE"
        : "PERSONAL";
}

export function removeItemsByPattern(pattern) {
    // 创建一个正则表达式对象
    const regex = new RegExp(pattern);

    // 获取 localStorage 的键名数组
    const keys = Object.keys(localStorage);
    // 遍历所有的键名
    keys.forEach((key) => {
        // 检查键名是否匹配正则表达式
        if (regex.test(key)) {
            // 匹配则删除该项
            localStorage.removeItem(key);
        }
    });
}

export function logout() {
    try {
        localStorage.removeItem(tokenKey);
        removeItemsByPattern("^fcw_web_token_");
        window.$store.commit("user/editUserId", "");
        window.$store.commit("user/editOpenId", "");
        window.$store.commit("user/editToken", "");
        window.$store.commit("user/editRoles", []);
        // window.$store.commit("user/editLoginId", "personal");
        window.location.reload();
    } catch (e) {
        console.log(e, "e");
    }
}
